import { FC } from 'react'
import { NavLink } from 'react-router-dom'

import { Li } from './styled'

export const MenuItem: FC<{ href: string }> = ({ children, href }) => (
  <Li>
    <NavLink to={href}>{children}</NavLink>
  </Li>
)
